import {
  Stepper,
  Step,
  StepLabel,
  Box,
  Typography,
  Link,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Link as RouterLink } from "react-router";
import { OnboardingStep } from "../types/OnboardingStep";

interface OnboardingStepperProps {
  activeStep: number;
  steps: OnboardingStep[];
  orientation?: "horizontal" | "vertical";
}

export const OnboardingStepper = ({
  activeStep,
  steps,
  orientation = "horizontal",
}: OnboardingStepperProps) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  // stepper takes up too much real estate on small screens
  if (isSmall) return null;

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper activeStep={activeStep} orientation={orientation}>
        {steps.map(
          ({ label, completedLabel, shortLabel, description, index, href }) => {
            const isCompleted = index < activeStep;
            const completedOrNotLabel = isCompleted ? completedLabel : label;
            const displayLabel =
              orientation === "vertical" ? completedOrNotLabel : shortLabel;

            return (
              <Step key={label}>
                <StepLabel>
                  {isCompleted ? (
                    <Link component={RouterLink} to={href}>
                      {displayLabel}
                    </Link>
                  ) : (
                    <span>{displayLabel}</span>
                  )}
                  {orientation === "vertical" && index === activeStep && (
                    <Typography variant="body2" color="text.secondary">
                      {description}
                    </Typography>
                  )}
                </StepLabel>
              </Step>
            );
          },
        )}
      </Stepper>
    </Box>
  );
};
